<script setup lang="ts">
import { MousePointer2, ChartColumn, History, ChevronsLeft, ChevronsRight } from "@lucide/vue";

import SidebarNavItem from "./SidebarNavItem.vue";

defineProps<{
  isExpanded: boolean;
}>();

const emit = defineEmits<{
  toggle: [];
}>();
</script>

<template>
  <div
    class="pb-px-8 flex h-full flex-col"
    :class="isExpanded ? 'gap-4' : 'gap-1 pt-2'">
    <!-- Header geometry is shared with ProjectNavigation so the two sub-sidebars still read the same
         when you move between them: expanded it's the h-px-46 + inset-bottom-shadow row that a page
         header is, so the hairline sits on the page header's baseline (RTLCA-5387); collapsed it
         keeps the pt-2 + h-fit offset that the icon rail is spaced against. -->
    <div
      class="flex shrink-0 items-center px-2"
      :class="
        isExpanded ? 'h-px-46 justify-between shadow-[inset_0_-1px_0_0_var(--color-slate-200)]' : 'h-fit justify-center pb-1'
      ">
      <h2
        v-if="isExpanded"
        class="text-app-blue-900 t-sh3 px-2.5">
        AI Agent
      </h2>
      <button
        type="button"
        :aria-expanded="isExpanded"
        :aria-label="isExpanded ? 'Collapse AI Agent navigation' : 'Expand AI Agent navigation'"
        class="focus-ring interactive-active rounded-8 text-type-muted hover:text-type-default flex h-7 w-7 items-center justify-center hover:bg-slate-200"
        @click="emit('toggle')">
        <component
          :is="isExpanded ? ChevronsLeft : ChevronsRight"
          class="icon-sm"
          :stroke-width="1.5" />
      </button>
    </div>
    <section class="flex flex-col">
      <h3
        v-if="isExpanded"
        class="t-caption text-slate-450 pb-px-6 pl-px-18 pr-4 tracking-wide uppercase">
        Personal
      </h3>
      <div class="flex flex-col gap-1 px-2">
        <SidebarNavItem
          label="Skills"
          to="/agent/skills"
          :icon-component="MousePointer2"
          :active-names="['skills', 'agent']"
          link-id="sub-sidebar-agent-skills-nav-link"
          padding-class="px-2.5 py-1.5"
          :is-expanded="isExpanded" />
        <SidebarNavItem
          label="Usage"
          to="/agent/usage"
          :icon-component="ChartColumn"
          :active-names="['agentUsage']"
          link-id="sub-sidebar-agent-usage-nav-link"
          padding-class="px-2.5 py-1.5"
          :is-expanded="isExpanded" />
        <SidebarNavItem
          label="History"
          to="/agent/usage/history"
          :icon-component="History"
          :active-names="['agentUsageHistory']"
          link-id="sub-sidebar-agent-history-nav-link"
          padding-class="px-2.5 py-1.5"
          :is-expanded="isExpanded" />
      </div>
    </section>
  </div>
</template>
